// extracted by mini-css-extract-plugin
export default {"actionsMenu":"ActionsMenu_actionsMenu__aohbB","icon":"ActionsMenu_icon__Tpmbx"};